import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdministratorService } from '../../../../services/administrator.service';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'src/app/services/shared/dialog.service';

@Component({
  selector: 'app-dialog-logs',
  templateUrl: './dialog-logs.component.html',
  styleUrls: ['./dialog-logs.component.scss']
})
export class DialogLogsComponent {
	item: any;
	logs: any;
	message: string;
	displayedColumns: string[] = ['line','profile', 'email', 'status', 'message'];

  constructor(
    private dialog: DialogService,
    private administratorService: AdministratorService,
    private translateService: TranslateService,
    public dialogRef: MatDialogRef<DialogLogsComponent>,
	private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.item = data.item;
	this.logs = JSON.parse(this.item.logs);
    this.message = this.translate.instant('documents.titles.logs_subtitle', {
      nb_lines: this.item.nb_lines,
      nb_errors: this.item.nb_errors,
      nb_adds: this.item.nb_adds,
      nb_updates: this.item.nb_updates,
      nb_deletes: this.item.nb_deletes

    });


  }

  onClose(): void {
    this.dialogRef.close();
  }

  openLoginWithOtherAccountDialog(item: any): void {
		const dialogRef = this.dialog.showConfirm(
			this.translateService.instant('user_search.labels.confirm_account_change')
		);

		dialogRef.afterClosed().subscribe((confirm: boolean) => {
			if (confirm === true) {
				this.loginWithOtherAccount(item);
			}
		});
	}

	loginWithOtherAccount(item: any): void {
		this.administratorService.loginWithOtherAccount(item.user_id).subscribe((response) => {
			window.open(response.data.redirect, '_blank');
		}, (error) => {
			console.log(error);
		});
	}


}